<template>
  <div class="plans">
    <div class="top-action">
      <div class="top-title">认定申请</div>
      <div class="top-right">
        <div class="apply-time" v-if="identityStartTime">
          申请时段：{{ `${identityStartTime} - ${identityEndTime}` }}
        </div>
        <a-button type="primary" a-button @click="handleApply" class="apply-btn"
          ><div class="top-apply-btn">
            <a-icon type="plus" />认定申请
          </div></a-button
        >
      </div>
    </div>
    <a-spin :spinning="applySpinning">
      <div class="content">
        <table class="table">
          <tr>
            <th>序号</th>
            <th>认定类别</th>
            <th v-if="isAllowCert == 1">证书名称</th>
            <th>认定学分</th>
            <th>申请时间</th>
            <th>审核状态</th>
            <th>审核意见</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in arr" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.creditsTypeName }}</td>
            <td v-if="isAllowCert == 1">{{ item.creditsCertName }}</td>
            <td>{{ item.approveCredit }}</td>
            <td>{{ item.createTime }}</td>
            <td>
              <div :style="{ color: colorList[item.status] }">
                {{ statusList[item.status] }}
              </div>
            </td>
            <td>
              <div class="audit-text">
                <a-tooltip
                  v-if="item.status == 2"
                  overlayClassName="audit-tooltip"
                >
                  <template slot="title"
                    ><div
                      :style="{ color: item.status == 2 ? 'red' : '#212529' }"
                    >
                      {{ item.approveDesc }}
                    </div></template
                  >
                  <div :style="{ color: 'red' }">
                    {{ item.approveDesc }}
                  </div></a-tooltip
                >
                <div v-else>
                  {{ item.approveDesc }}
                </div>
              </div>
            </td>
            <td>
              <div v-if="item.status == 1">
                <button
                  class="btn btn-inter"
                  style="width: 60px; margin-left: 30px"
                  @click="gotoExchange(item)"
                >
                  去兑换
                </button>
                <button
                  style="margin-left: 5px; background: #2caf7a"
                  class="btn"
                  @click="handleExchangeLog(item)"
                >
                  兑换日志
                </button>
              </div>
              <div v-if="item.status == 0">
                <a-popconfirm
                  title="确定撤销申请吗?"
                  @confirm="() => handleCancelApply(item.id)"
                >
                  <button
                    style="margin-left: 5px; background: #69a6da"
                    class="btn"
                  >
                    撤销申请
                  </button>
                </a-popconfirm>
              </div>
              <div v-if="item.status == 2 || item.status == 3">
                <button
                  style="background: #f5758a"
                  class="btn"
                  @click="() => handleReApply(item)"
                >
                  重新申请
                </button>
              </div>
            </td>
          </tr>
        </table>
        <div class="pagination">
          <a-pagination show-quick-jumper :default-current="1" :total="total" :current="pageNo" :pageSize="pageSize" @change="onChange" />
        </div>
      </div>
    </a-spin>
    <!-- 兑换课程弹窗 -->
    <a-modal
      title="兑换课程"
      :visible="visibleExchange"
      @cancel="handleCancel"
      width="50%"
      :bodyStyle="{ paddingBottom: 0 }"
      destroyOnClose
    >
      <div class="exchange-modal">
        <a-table
          rowKey="subjectCode"
          :columns="columnsExchange"
          :data-source="dataSourceExchange"
          bordered
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
        />
        <div class="tip-text">课程兑换成功后，不退不改</div>
      </div>

      <template slot="footer">
        <div class="exchange-footer">
          <div class="footer-text">
            认定学分：{{ totalNum }}分 已兑换：{{ usedNum }}分 剩余：<span
              style="color: #ff0000"
              >{{ leftNum }}分</span
            >
          </div>
          <a-button type="primary" class="sure-btn" @click="handleExchangeSure"
            >确定兑换</a-button
          >
        </div>
      </template>
    </a-modal>

    <!-- 日志弹窗 -->
    <a-modal
      title="兑换日志"
      :visible="visibleLog"
      @cancel="handleLogCancel"
      width="50%"
      :bodyStyle="{ paddingBottom: 0 }"
      destroyOnClose
    >
      <div class="exchange-modal">
        <a-table
          :rowKey="
            (record, index) => {
              return index;
            }
          "
          :columns="columnsLog"
          :data-source="dataSourceLog"
          bordered
          :pagination="false"
        />
      </div>

      <template slot="footer">
        <div class="log-text">
          认定学分：{{ totalNum }}分 已兑换：{{ usedNum }}分 剩余：<span
            style="color: #ff0000"
            >{{ leftNum }}分</span
          >
        </div>
      </template>
    </a-modal>

    <!-- 兑换成功弹窗 -->
    <a-modal
      title=""
      :visible="visibleSuccess"
      @cancel="handleSuccessCancel"
      width="360px"
      :bodyStyle="{ padding: '16px' }"
      :footer="null"
    >
      <div class="success-modal">
        <img src="../../../assets/images/log-success.png" />
        <div class="success-text">恭喜你，兑换成功！</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ApplyList",
  data: function () {
    return {
      arr: [],
      applyTime: "2024-10-01-2024-10-31",
      applySpinning: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      identifyId: "",
      statusList: ["待审核", "通过", "失败", "已撤销"], // 0待审核   1审核通过   2审核拒绝   3已撤销
      colorList: ["#2caf7a", "#212529", "#ff0000", "#909090"], // 待审核  通过  失败   已取消
      isBetween: true,
      isAllowCert: false, // 是否使用证书
      identityStartTime: "", // 申请开始时间
      identityEndTime: "", // 申请结束时间
      totalNum: "", // 总可用学分
      usedNum: "", // 已用学分
      leftNum: "", // 剩余学分
      visibleExchange: false,
      columnsExchange: [
        {
          align: "left",
          title: "课程名称",
          dataIndex: "viewName",
        },
        {
          align: "center",
          title: "所需学分",
          dataIndex: "lessonPeriod",
        },
        {
          align: "center",
          title: "等价成绩",
          dataIndex: "equivalentScore",
        },
      ],
      dataSourceExchange: [],

      visibleLog: false,
      columnsLog: [
        {
          align: "center",
          title: "兑换时间",
          dataIndex: "chargeTime",
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : "",
              attrs: {},
            };
            obj.attrs.rowSpan = this.mergeCells(
              text,
              this.dataSourceLog,
              "chargeTime",
              index
            );
            return obj;
          },
        },
        {
          align: "center",
          title: "总用学分",
          dataIndex: "chargeCredit",
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : "",
              attrs: {},
            };
            obj.attrs.rowSpan = this.mergeCells(
              record.chargeTime,
              this.dataSourceLog,
              "chargeTime",
              index
            );
            return obj;
          },
        },
        {
          align: "left",
          title: "兑换课程",
          dataIndex: "viewName",
        },
        {
          align: "center",
          title: "学分明细",
          dataIndex: "lessoinPeriod",
        },
        {
          align: "center",
          title: "等价成绩",
          dataIndex: "equivalentScore",
        },
      ],
      dataSourceLog: [],
      visibleSuccess: false,
      selectedRowKeys: [],
      selectionRows: [],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    getList() {
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.applySpinning = true;
      this.axios
        .get(`/biz/credit/identified/list`, {
          params,
        })
        .then((res) => {
          if (res.success) {
            this.arr = res.result.records;
            this.total = res.result.total;
          }
        })
        .finally(() => {
          this.applySpinning = false;
        });
    },
    // 计算当前时间是否在给定的时间字符中间
    isBetweenDates(start, end) {
      // 解析日期字符串为 Date 对象
      const startDate = new Date(start);
      const endDate = new Date(end);
      const now = new Date();
      this.isBetween = now >= startDate && now <= endDate;
    },
    // 学校配置查询
    getSchoolConfig() {
      this.axios.get(`/biz/credit/param`).then((res) => {
        if (res.success) {
          this.isAllowCert = res.result.isAllowCert;
          this.identityStartTime = res.result.identityStartTime;
          this.identityEndTime = res.result.identityEndTime;
          this.isBetweenDates(
            res.result.identityStartTime,
            res.result.identityEndTime
          );
        }
      });
    },
    // 获取学分使用信息
    getCreditInfo(id) {
      this.axios
        .get(`/biz/credit/qry/period`, {
          params: {
            identifyId: id || this.identifyId,
          },
        })
        .then((res) => {
          if (res.success) {
            this.totalNum = res.result.totalNum;
            this.usedNum = res.result.usedNum;
            this.leftNum = res.result.leftNum;
          }
        });
    },

    onChange(index) {
      this.pageNo = index;
      this.getList();
    },
    handleApply() {
      if (!this.isBetween) {
        this.$message.warning("当前时间不可申请");
        return;
      }
      this.$router.push({
        path: "/creditApplication",
        query: {
          isAllowCert: this.isAllowCert
        },
      });
    },
    // 获取可兑换课程列表
    getSubject() {
      this.axios
        .get(`/biz/credit/charge/qrySubject`, {
          params: { identifyId: this.identifyId },
        })
        .then((res) => {
          if (res.success) {
            this.dataSourceExchange = res.result;
          }
        });
    },
    gotoExchange(item) {
      this.identifyId = item.id;
      this.selectedRowKeys = [];
      this.visibleExchange = true;
      this.getSubject();
      this.getCreditInfo(item.id);
    },
    handleCancel() {
      this.visibleExchange = false;
    },
    handleExchangeSure() {
      const params = {
        identifyId: this.identifyId,
        subjectCodes: this.selectedRowKeys.join(","),
      };
      this.axios.post(`/biz/credit/charge/submit`, params).then((res) => {
        if (res.success) {
          this.visibleExchange = false;
          this.visibleSuccess = true;
        }
      });
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    // 获取兑换日志列表
    getExchangeLog() {
      this.axios
        .get(`/biz/credit/identified/chargeLog`, {
          params: { identifyId: this.identifyId },
        })
        .then((res) => {
          if (res.success) {
            this.dataSourceLog = res.result.flatMap((item) =>
              item.chargeDetailInfos.map((detail) => {
                return {
                  ...item,
                  lessoinPeriod: detail.lessoinPeriod,
                  equivalentScore: detail.equivalentScore,
                  subjectCode: item.subjectCode,
                  viewName: detail.viewName,
                };
              })
            );
          }
        });
    },
    mergeCells(text, data, key, index) {
      // 上一行该列数据是否一样
      if (index !== 0 && text === data[index - 1][key]) {
        return 0;
      }
      let rowSpan = 1;
      // 判断下一行是否相等
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) {
          break;
        }
        rowSpan++;
      }
      return rowSpan;
    },
    handleExchangeLog(item) {
      this.identifyId = item.id;
      this.visibleLog = true;
      this.getExchangeLog();
      this.getCreditInfo(item.id);
    },
    handleLogCancel() {
      this.visibleLog = false;
    },
    handleSuccessCancel() {
      this.visibleSuccess = false;
    },
    // 撤销申请
    handleCancelApply(id) {
      this.axios
        .get(`/biz/credit/identified/cancel`, {
          params: { identifyId: id },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success("操作成功");
            this.getList();
          }
        });
    },
    // 重新申请
    handleReApply(item) {
      this.$router.push({
        path: "/creditApplication",
        query: {
          id: item.creditsTypeId,
          creditsTypeName: item.creditsTypeName,
          creditsCertId: item.creditsCertId,
          creditsCertName: item.creditsCertName,
          applyDesc: item.applyDesc,
          applyReason: item.applyReason,
          applyCredit: item.applyCredit,
          isAllowCert: this.isAllowCert
        },
      });
    },
  },
  created() {
    this.getList();
    this.getSchoolConfig();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.plans {
  min-height: calc(100vh - 584px);

  .content {
    background: #fff;
    padding: 28px;
    .pagination {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 30px 0;
    }

    .result {
      background: #f8faf9;
      padding: 20px;
      margin-bottom: 30px;
      margin-top: 10px;
      color: #999999;
      width: 100%;

      strong {
        font-weight: bold;
        margin-right: 20px;
        color: #333;
      }
    }
  }

  .btn {
    width: 80px;
    height: 26px;
    line-height: 26px;
    padding: 0;
    background: #cbccce;
    text-align: center;
    color: #fff;
    border: none;
    border-radius: 4px;
  }

  .btn-inter {
    background: #F6AD3B !important;
  }

  .active {
    background: $bgColor;
  }

  th {
    text-align: center;
    background: #f6f6f8;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  td {
    text-align: center;
    vertical-align: middle;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  tr:nth-child(odd) {
    background: #f6f6f8;
  }
}
.exchange-modal {
  padding-bottom: 24px;
    /deep/ th {
        text-align: center;
        background: #f6f6f8;
        padding: 6px;
        font-weight: bold;
      }
      /deep/ td {
        text-align: center;
        padding: 6px;
      }
    .tip-text {
        text-align: center;
        margin: 6px;
        color: #FF0000;
        font-size: 15px;
    }
}
.exchange-footer {
    display: flex;
    justify-content: space-between;
    .footer-text {
        font-size: 14px;
        color: #999999;
        line-height: 32px;
    }
}
.sure-btn {
    background: #F6AD3B;
    border: 1px solid #F6AD3B;
}
.log-text {
    text-align: center;
}
.success-modal {
    height: 168px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .success-text {
        color: #333333;
        font-size: 18px;
        margin-top: 24px;
    }
}
.top-action {
    display: flex;
    justify-content: space-between;
    .top-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom:30px;
    }
    .top-right {
        display: flex;
        gap: 16px;
        .apply-time {
            margin-top: 8px;
            color: #000000;
        }
    }
}
.apply-btn {
    width: 100px;
    height: 30px;
    line-height: 30px;
    padding: 0;
    background: #2caf7a;
    text-align: center;
    color: #fff;
    border: none;
    border-radius: 15px;
}
.top-apply-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}
.audit-text {
  max-width: 500px;
  width: 300px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 显示省略号 */
}
</style>
<style>
.audit-tooltip .ant-tooltip-inner {
  background-color: #ffffff !important;
  color: #fff;
}
.audit-tooltip .ant-tooltip-arrow::before {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/creditBank/components/ApplyList.vue